import React from 'react';
import { motion } from 'framer-motion';
import { CountdownTimer } from './CountdownTimer';
export function BottomPricing() {
  return <section className="py-16 px-4 bg-dark-card border-t border-dark-border pt-[25px] pb-[25px]" data-id="element-77">
      <div className="max-w-lg mx-auto" data-id="element-78">
        <div className="text-center mb-10" data-id="element-79">
          <div className="text-white font-bold mb-4 tracking-widest text-sm flex items-center justify-center gap-2" data-id="element-80">
            <span data-id="element-81">🚨</span>
            <span data-id="element-82">EL PRECIO DE LANZAMIENTO CIERRA EN:</span>
          </div>
          <CountdownTimer data-id="element-83" />
        </div>

        <div className="flex flex-col gap-6" data-id="element-84">
          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="bg-dark border border-dark-border rounded-2xl p-6 text-center" data-id="element-85">
            <div className="text-3xl mb-2" data-id="element-86">📘</div>
            <h3 className="font-black text-lg text-white tracking-wide" data-id="element-87">
              PROTOCOLO MENTE INDOMABLE™
            </h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-88">4 Tomos + 4 Bonos</p>

            <div className="mt-5" data-id="element-89">
              <div className="text-gray-500 line-through text-sm" data-id="element-90">
                Antes: $29.990 ARS
              </div>
              <div className="text-3xl md:text-4xl font-black text-white mt-1" data-id="element-91">
                Hoy: $19.990 ARS
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47899222474926:1" target="_blank" rel="noopener noreferrer" className="mt-5 w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(245,158,11,0.3)] text-base" data-id="element-92">
              → QUIERO MI PROTOCOLO
            </a>
          </motion.div>

          <motion.div initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="bg-dark border-2 border-brand rounded-2xl p-6 text-center shadow-[0_0_40px_rgba(245,158,11,0.15)]" data-id="element-93">
            <div className="text-3xl mb-2" data-id="element-94">🏆</div>
            <h3 className="font-black text-lg text-white tracking-wide" data-id="element-95">
              PROTOCOLO MENTE INDOMABLE™ + MÉTODO BLINDAJE™ ⭐ LA MÁS ELEGIDA
            </h3>
            <p className="text-gray-400 text-sm mt-1" data-id="element-96">
              4 Tomos + 4 Bonos + MÉTODO BLINDAJE™
            </p>

            <div className="mt-5" data-id="element-97">
              <div className="text-gray-500 line-through text-sm" data-id="element-98">
                Antes: $38.990 ARS
              </div>
              <div className="text-3xl md:text-4xl font-black text-brand mt-1" data-id="element-99">
                Hoy: $27.990 ARS
              </div>
            </div>

            <a href="https://ultrapack.digital/cart/47899226308782:1" target="_blank" rel="noopener noreferrer" className="mt-5 w-full block text-center bg-brand hover:bg-brand-dark text-white font-bold py-4 px-6 rounded-xl transition-all hover:scale-[1.02] shadow-[0_0_30px_rgba(245,158,11,0.4)] text-base" data-id="element-100">
              → QUIERO EL PROTOCOLO + MÉTODO BLINDAJE™
            </a>
          </motion.div>
        </div>

        <div className="max-w-2xl mx-auto mt-12 text-center" data-id="element-101">
          <h3 className="font-black text-xl text-white mb-4" data-id="element-102">
            Una última cosa antes de irte.
          </h3>
          <div className="text-left text-gray-300 text-sm leading-relaxed space-y-4" data-id="element-103">
            <p data-id="element-104">Hay dos tipos de hombres de 50 años.</p>
            <p data-id="element-105">
              El primero acepta que la mente se deteriora con la edad, que los
              olvidos son normales, que la lentitud es inevitable y que lo mejor
              que puede hacer es adaptarse. Ese hombre llega a los 65
              dependiendo de otros para recordar, para decidir y para resolver.
            </p>
            <p data-id="element-106">
              El segundo entiende que el cerebro responde al entrenamiento a
              cualquier edad, que el deterioro cognitivo no es un destino sino
              una consecuencia de la falta de mantenimiento, y que 30 minutos
              por día son suficientes para cambiar completamente la trayectoria
              de su mente para los próximos 20 años.
            </p>
            <p data-id="element-107">
              Vos estás acá. Eso ya dice algo sobre qué tipo de hombre sos. El
              Protocolo Mente Indomable es para el segundo tipo.
            </p>
            <p data-id="element-108">
              El sistema está listo. Los tomos están escritos. Los bonos están
              cargados. El Método Blindaje espera. Lo único que falta es la
              decisión.
            </p>
            <p className="text-brand font-bold" data-id="element-109">
              Y hoy, a este precio, esa decisión es la más fácil que vas a tomar
              esta semana.
            </p>
            <p className="italic text-gray-400 text-center mt-6" data-id="element-110">
              "La mente no se mantiene sola. Se entrena, se protege y se cuida.
              O se deja estar."
            </p>
          </div>
        </div>
      </div>
    </section>;
}